import {ChaosState} from './../../reducer'

export const getChaosRegisteredComponents = (state: ChaosState): {[queryName: string]: boolean} =>
  state.componentChaos.registeredComponents

export const getChaosFailedComponentRenders = (state: ChaosState): {[queryName: string]: boolean} =>
  state.componentChaos.failureComponents
